import { render, staticRenderFns } from "./WallPreview.vue?vue&type=template&id=04e0104e"
import script from "./WallPreview.vue?vue&type=script&lang=js"
export * from "./WallPreview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports